export const paths = {
  // Auth
  authError: (code?: string) => {
    const errorUrl = '/auth/error';

    if (!code) {
      return errorUrl;
    }

    return `${errorUrl}?code=${encodeURIComponent(code)}` as const;
  },
  login: (returnTo?: string) => {
    const loginUrl = '/auth/auth0?prompt=login';

    if (!returnTo) {
      return loginUrl;
    }

    return `${loginUrl}&returnTo=${encodeURIComponent(returnTo)}` as const;
  },
  logout: '/auth/logout',

  // App root
  app: '/app',

  // Marketplace
  marketplace: '/app/marketplace',
  marketplaceDiscover: '/app/marketplace/discover',

  // Orders
  orders: '/app/orders',
  order: (orderId: string) => `/app/orders/${orderId}`,
  orderLomn: (orderId: string) => `/app/orders/${orderId}/lomn`,

  // Patients
  patients: '/app/patients',
  patient: (patientId: string) => `/app/patients/${patientId}`,

  // Profile
  profile: '/app/profile',
  profileMemberRequests: '/app/profile/member-requests',
  profileNotificationPreferences: '/app/profile/notification-preferences',

  // Checkout
  checkout: '/app/checkout',
  checkoutPatientInfo: '/app/checkout/patient-info',
  // D2C-mirror version of the intake-first prototype.
  checkoutCoverage: '/app/checkout/coverage',
  checkoutInsurance: '/app/checkout/insurance',
  checkoutReview: '/app/checkout/review',
  checkoutClinical: '/app/checkout/clinical',
  checkoutClinicalTelehealth: '/app/checkout/clinical/telehealth',
  checkoutClinicalTelehealthSchedule: '/app/checkout/clinical/telehealth/schedule',
  checkoutClinicalUpload: '/app/checkout/clinical/upload',

  // Checkout complete
  checkoutComplete: '/app/checkout/complete',
  checkoutCompleteUpload: (orderId: string) => `/app/checkout/complete/upload/${orderId}`,
  checkoutCompleteTelehealthScheduled: (orderId: string) =>
    `/app/checkout/complete/telehealth-scheduled/${orderId}`,
  checkoutCompleteTelehealthCoordinate: (orderId: string) =>
    `/app/checkout/complete/telehealth-coordinate/${orderId}`,

  // Admin
  admin: '/app/admin',
  adminUsers: '/app/admin/users',
  adminOrganizations: '/app/admin/organizations',
  adminCarriers: '/app/admin/carriers',
  adminPlans: '/app/admin/plans',
  adminCatalog: '/app/admin/catalog',
} as const;
